import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { toLocalDate2 } from "../../../utils";
import { DETAILS_APIS, MANAGEMENT_APIS, REPORT_APIS } from "../../../common/apis";
import UnitAdhocReportTable from "./UnitAdhocReportTable";
import { DataGridAction } from "../../../components/DataTable";
import { ExcelIcon } from "../../../icons/ButtonIcons";
import { useWindowPopups, WindowTypes } from "../../../components/useWindowPopups";

export default function AdhocUnitReport({ allData }) {

  const { get, getFile } = useFetch();

  const [unitDetails, setUnitDetails] = useState({});
  const [localData, setLocalData] = useState({});
  const [unitAdHocData, setUnitAdHocData] = useState({});

  async function adHocUnitExcelClick() {
    await getFile(`${MANAGEMENT_APIS?.EXPORT_UNIT_ADHOC_REPORT}?unitId=${allData?.UnitId || localData?.UnitId}`, "UNIT ADHOC REPORT");
  }
  async function exportAdhocReport(row) {
    await getFile(`${REPORT_APIS?.VIEW_SPECIAL_MAIL_REPORT}?reportNumber=${row?.ReportNumber}`, "Adhoc Report File");
  }
  async function editAdhocReport(row) {
    var actionName = 'edit-special-unit-report';
    if (Object.values(WindowTypes).includes(actionName)) {
      HandleNewWindow(actionName, row);
      return;
    }
  }


  const HandleNewWindow = (actionName, data) => {
    useWindowPopups(actionName, data)
  }



  async function getData(data) {
    let resData = await get(`${DETAILS_APIS?.UNIT_HISTORY}?UnitId=${data?.UnitId || 0}&ResultsView=0`);
    if (resData) {
      setUnitDetails(resData?.UnitHistorySimpleHeader[0] || {});
    }
    let res = await get(`${MANAGEMENT_APIS?.UNIT_ADHOC_REPORT}?unitId=${data?.UnitId || 0}`);
    if (res) {
      setUnitAdHocData(res);
    }
  }
  //get data for grid
  useEffect(() => {
    (async function () {
      let parseData = JSON.parse(localStorage.getItem("recent-unit-results"));
      if (parseData !== null && parseData !== undefined) {
        setLocalData(parseData)
        getData(parseData)
      }
      if (allData?.UnitId > 0) {
        getData(allData)
      }
    })();
  }, []);


  useEffect(() => {
    function handleStorageChange(event) {
      if (event.key === "adhoc-report-refresh" && event.newValue === "true") {
        // Refresh data
        const stored = JSON.parse(localStorage.getItem("recent-unit-results"));
        if (stored) {
          setLocalData(stored);
          getData(stored);
        } else if (allData?.UnitId > 0) {
          getData(allData);
        }

        localStorage.removeItem("adhoc-report-refresh");
      }
    }

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [allData]);

  return (
    <>
      <Grid container minWidth={"66vw"}>
        <Grid item xs={12}>
          <Typography>{`${unitDetails?.Product || ""} ${unitDetails?.Customer || ""
            } ${unitDetails?.Site || ""} ${unitDetails?.Unit || ""} ${unitDetails?.UnitModelFormatted || ""
            }`}</Typography>
        </Grid>

        {unitAdHocData.length > 0 && (
          <Grid item xs={6}>
            <Tooltip
              title="Export Unit Adhoc Report Table"
              arrow
            >
              <span> 
                <Button
                  sx={{ mt: 1 }}
                  onClick={adHocUnitExcelClick}
                  startIcon={<ExcelIcon />}
                  disabled={!(allData?.UnitId > 0 || localData?.UnitId > 0)}
                >
                  Export
                </Button>
              </span>
            </Tooltip>
          </Grid>
        )}
        <Grid item xs={12} mt={0.2} mb={0}>
          <Typography variant="subtitle2" mb={0}>
            Total Records: <b> {unitAdHocData.length}</b>
          </Typography>
        </Grid>
        <Grid item xs={12} mt={0.5}>
          <UnitAdhocReportTable
            columns={
              GetColumns(exportAdhocReport, editAdhocReport)
            }
            data={
              unitAdHocData
            }
          />
        </Grid>
      </Grid>
    </>
  );
}

const GetColumns = (exportAdhocReport, editAdhocReport) => [
  {
    headerName: "ReportNumber",
    field: "ReportNumber",
    width: 100,
  },
  {
    headerName: "AdHoc Report Type",
    field: "AdHocReportType",
    width: 150,
  },
  {
    headerName: "Type Short",
    field: "AdHocReportTypeShort",
    width: 100,
  },
  {
    headerName: "Site",
    field: "Site",
    width: 150,
  },
  {
    headerName: "Billing Rate",
    field: "BillingRate",
    width: 100,
  },
  {
    headerName: "Hours",
    field: "Hours",
    width: 100,
  },
  {
    headerName: "IsArchived",
    field: "IsArchived",
    width: 100,
    valueFormatter: ({ value }) => (value ? "True" : "False"),
  },

  {
    headerName: "IsExternal",
    field: "IsExternal",
    width: 100,
    valueFormatter: ({ value }) => (value ? "True" : "False"),
  },
  {
    headerName: "Sampled",
    field: "Sampled",
    width: 100,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },
  {
    headerName: "Created",
    field: "Created",
    width: 120,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },
  {
    headerName: "Action",
    field: "AdhocReport",
    sortable: false,
    minWidth: 145,
    renderCell: function ({ row }) {
      return (
        <>
          <DataGridAction row={row} onClick={editAdhocReport} label="Edit" sx={{ mr: 0.2 }} />
        {row?.HasAdHocReport && (
          <Tooltip title="Export Adhoc Report File" arrow>
            <span>
              <DataGridAction
                row={row}
                onClick={exportAdhocReport}
                label="Export"
              />
            </span>
          </Tooltip>
        )}
        </>
      );
    },
  },
];


